import React from "react";
import { Link } from "react-router-dom";

const CustomButtonLink = ({ to, label }) => {
  return (
    <div className="flex justify-center md:justify-start">
      <Link
        to={to}
        className="py-[12px] lg:py-[16px] px-4 sm:px-5 lg:px-10 hover:bg-btnhover bg-orangebg  rounded-[12px] sm:rounded-[16px]"
      >
        <p className="sm:text-base text-12 font-semibold text-white">
          {label}
        </p>
      </Link>
    </div>
  );
};

export default CustomButtonLink;